type StoredItem<T> = {
  value: T,
  exp: number | null,
}

/**
 * localStorage wrapper with optional expiry.
 * The prefix must stay '@palchiki-site' so saved logins and UTM survive the rewrite.
 */
export class Storage {

  static prefix = '@palchiki-site'

  static composeKey(key: string): string {
    return `${Storage.prefix}:${key}`
  }

  static get isDefined(): boolean {
    return typeof localStorage !== 'undefined'
  }

  static setItem<T>(key: string, item: T, exp: number | null = null): void {
    if (Storage.isDefined) {
      const stored: StoredItem<T> = { value: item, exp }
      localStorage.setItem(Storage.composeKey(key), JSON.stringify(stored))
    }
  }

  static getItem<T = unknown>(key: string): T | null {
    if (!Storage.isDefined) {
      return null
    }
    const saved = localStorage.getItem(Storage.composeKey(key))
    if (!saved) {
      return null
    }
    try {
      const item = JSON.parse(saved) as StoredItem<T>
      if (item.exp && item.exp < Date.now()) {
        return null
      }
      return item.value
    } catch {
      return null
    }
  }

  static deleteItem(key: string): void {
    if (Storage.isDefined) {
      localStorage.removeItem(Storage.composeKey(key))
    }
  }

}
